/**
 * 录音分享
 */
import $share from '@/api/modules/share'
import { AsyncRequest } from '@/utils/request'

const state = {
  soundRecordShareInfo: {}
}

const getters = {
  couponInfo: state => {
    console.log('state 123', state)
    return state.shareCouponDetail
  }
}

const mutations = {
  setShareCouponDetail: (state, info) => {
    state.shareCouponDetail = info
  },
  setobtainCoupon: (state, info) => {
    state.setobtainCoupon = info
  }
}

const actions = {
  // 获取分享的优惠券详情
  getShareCouponDetail({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => $share.getShareCouponDetail(data),
      resolve: (info) => commit('setShareCouponDetail', info)
    })
  },
  // 领取优惠券
  obtainCoupon({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => $share.obtainCoupon(data),
      resolve: (info) => commit('setobtainCoupon', info)
    })
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
